/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined, LoadingOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../../DashboardPage/GridComponents';
import { statsService } from '../../../../../utils/api';
import Table from '../../../../../components/Table';
import { groupBy, isEmpty, isUndefined } from 'lodash';
import Switch from 'components/forms/Switch';

const UserFeatures = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const [fetching, setFetching] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [cols, setCols] = useState([]);
    const [showRRUsers, setShowRRUsers] = useState(false);

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const formatData = (allData) => {
        const groupedByProperty = groupBy(allData, 'propertyName');
        const newData = [];
        Object.entries(groupedByProperty).forEach(([propertyName, propertyData]) => {
            const newPropertyData = propertyData.map((p) => ({
                ...p,
                propertyName: p.email,
                key: `${propertyName}-${p.email}`,
            }));
            newData.push({
                key: propertyName,
                propertyName,
                children: newPropertyData,
            });
        });
        return newData;
    };

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let response = {};
        if (individualPropertyID) {
            response = await statsService({
                token,
            }).getAccountManagementFeatures({ propertyID: individualPropertyID });
        } else {
            response = await statsService({
                token,
            }).getAccountManagementFeatures();
        }
        setRawData(response.data);
        setData(formatData(response.data));
        setFetching(false);
        setFetched(true);
    };

    const renderFlag = (val) => {
        if (isUndefined(val)) return '';
        return val === 1 ? (
            <CheckOutlined style={{ color: '#52c41a' }} />
        ) : (
            <CloseOutlined style={{ color: '#ff4d4f' }} />
        );
    };

    const defaultColumns = [
        {
            title: 'Property/User',
            dataIndex: 'propertyName',
            key: 'propertyName',
            align: 'left',
            width: '150px',
            sorter: (a, b) => a.propertyName.localeCompare(b.propertyName),
            defaultSortOrder: 'ascend',
            fixed: 'left',
        },
    ];

    const workOutColumns = () => {
        const colArray = [];
        if (!isEmpty(rawData)) {
            Object.getOwnPropertyNames(rawData[0]).forEach((p) => {
                if (!['email', 'propertyName', 'propertyUuid'].includes(p)) {
                    colArray.push({
                        title: p,
                        dataIndex: p,
                        key: p,
                        align: 'center',
                        width: '100px',
                        render: renderFlag,
                        sorter: (a, b) => a[p] - b[p],
                    });
                }
            });
        }
        setCols([...defaultColumns, ...colArray]);
    };

    const reformatData = () => {
        let fullData = { ...rawData };
        if (!isEmpty(propertyUuids)) {
            fullData = rawData.filter((d) => propertyUuids.includes(d.propertyUuid));
        }
        if (!showRRUsers) {
            fullData = rawData.filter((d) => !d.email.includes('@rightrevenue.co.uk'));
        }
        setData(formatData(fullData));
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        reformatData();
    }, [propertyUuids, showRRUsers]);

    useEffect(() => {
        workOutColumns();
        reformatData();
    }, [rawData]);
    return (
        <>
            <HeaderContainer>
                <Header>User Features</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                {fetching && <LoadingOutlined style={{ marginRight: '8px' }} />}
                {!fetching && fetched && (
                    <>
                        <div style={{ paddingTop: '5px', paddingBottom: '5px', fontSize: '14px' }}>
                            Show Right Revenue users <Switch onChange={setShowRRUsers} checked={showRRUsers} />
                        </div>
                        <Table
                            dataSource={data}
                            columns={cols}
                            pagination={{
                                pageSize: 31,
                                hideOnSinglePage: true,
                            }}
                            tableLayout="auto"
                            size="small"
                            scroll={{ y: 360, x: 16000 }}
                            expandable={{
                                defaultExpandAllRows: !!individualPropertyID,
                            }}
                        />
                    </>
                )}
            </ScrollableBodyTall>
        </>
    );
};

UserFeatures.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default UserFeatures;
